import { Input } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getThemeColor } from "Store/reducers/Auth/AuthSlice";
import "../App.css";

function EditableText({
  onEditDone,
  children,
  className,
  name,
  icon,
  editModeOn,
  placeholder,
  ...rest
}) {
  const [value, setvalue] = useState(children);
  const onEdit = (e) => {
    setvalue(e.target.value);
    onEditDone({ [name]: e.target.value });
  };

  const themeColor = JSON.parse(useSelector(getThemeColor));

  const props = {
    className: `${className} bg-transparent hover:bg-transparent placeholder-opacity-50 `,
    value,
    onChange: onEdit,
    prefix: icon,
    placeholder,
    style: {
      color: themeColor?.text,
      "--placeholder-color": themeColor?.text,
    },
    // autoFocus:true,
    ...rest,
  };
  return (
    <div className={` w-full`}>
      {true ? (
        <div className="w-full">
          {icon ? (
            <Input {...props} />
          ) : (
            <Input.TextArea {...props} autoSize classNames={"p-0 "} />
          )}
        </div>
      ) : (
        <span className={className} onClick={onEdit}>
          {icon}
          {children}
        </span>
      )}{" "}
    </div>
  );
}

export default EditableText;
